import React, { useEffect, useState } from 'react'
import {
  Box,
  Tabs,
  Tab
} from '@mui/material'
import { styled } from '@mui/system'
import HeaderWithPopoverUpdated from 'src/components/HeaderWithPopoverUpdated'
import { useGetMeAndWorkspaceQuery } from 'src/services/user-service'
import WebhookPage from 'src/components/integrationsAndWebhook/webhookPage'
import IntegrationsApiPage from 'src/components/integrationsAndWebhook/integrationApiPage'
import CommonUpgradeModal from 'src/components/leadsFinder/filters/commonUpgradeModal'
import { useGetCurrentPlanQuery } from 'src/services/billing-service'
import useUserVerification from 'src/hooks/useUserVerification'
import { planNames } from 'src/config.js'
import { useAuth } from 'src/auth/auth'

const StyledTabs = styled(Tabs)(({ theme }) => ({
  backgroundColor: '#E1E3EC',
  borderRadius: theme.shape.borderRadius,
  minHeight: '44px',
  padding: '4px',
  width: '100%',
  maxWidth: '357px', // limits width on larger screens
  [theme.breakpoints.down('sm')]: {
    width: '100%', // 100% width on small screens
    maxWidth: '100%'
  },
  '& .MuiTabs-indicator': {
    height: '100%',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: 'white',
    zIndex: 0
  }
}))

const StyledTab = styled(Tab)(({ theme }) => ({
  color: theme.palette.text.secondary,
  minHeight: '36px',
  zIndex: 1,
  textTransform: 'none',
  fontWeight: 500,
  '&.Mui-selected': {
    color: theme.palette.primary.main
  }
}))

const IntegrationsAndWebhookPage = () => {
  const { canEdit } = useAuth()
  const { data } = useGetMeAndWorkspaceQuery()
  const [, setWorkspace] = useState(null)
  const [tabValue, setTabValue] = useState(0)
  const [openOverlay, setOpenOverlay] = useState(false)
  const { isFreeUser, isEarlyBirdAccessUser, isAppSumoUser } = useUserVerification()
  const currentPlan = useGetCurrentPlanQuery()
  const planId = currentPlan?.currentData?.subscription?.sendingWarmup?.planId || currentPlan?.currentData?.subscription?.leads?.planId
  const planName = isEarlyBirdAccessUser ? 'earlyBird' : (planNames[planId] ?? 'free')

  const PLAN_MONTHLY_GROWTH = 'Monthly Growth'
  const PLAN_YEARLY_GROWTH = 'Yearly Growth'
  const PLAN_MONTHLY_INFINITY = 'Monthly Infinity'
  const PLAN_YEARLY_INFINITY = 'Yearly Infinity'
  const checkPlanForGrowthAndInfinty = () => {
    const planName = planNames[planId]
    return [PLAN_MONTHLY_GROWTH, PLAN_YEARLY_GROWTH, PLAN_MONTHLY_INFINITY, PLAN_YEARLY_INFINITY].includes(planName)
  }

  const handleOpenOverlay = () => {
    setOpenOverlay(true)
  }

  const handleCloseOverlay = () => {
    setOpenOverlay(false)
    setTabValue(0)
  }

  const handleWorkspaceChange = (newWorkspace) => {
    setWorkspace(newWorkspace)
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  useEffect(() => {
    setOpenOverlay(isFreeUser)
  }, [isFreeUser])

  return (

    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          width: '100%',
          height: '100%'
        }}
      >
        <Box
          sx={{
            width: '90%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center'
            // bgcolor: 'yellow',
          }}
        >
          <HeaderWithPopoverUpdated
            title='Integrations'
            onWorkspaceChange={handleWorkspaceChange}
            selectedTimeline={data?.workspace}
          />

          <Box sx={{ width: '100%', marginTop: '20px', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', ml: 0 }}>
            <StyledTabs
              value={tabValue}
              onChange={handleTabChange}
              onClick={handleOpenOverlay}
              variant='fullWidth'
              aria-label='subscription tabs'
            >
              <StyledTab
                label='API'
              />
              <StyledTab
                label='Webhook'
              />
            </StyledTabs>
          </Box>

          <Box sx={{ width: '100%' }}>
            {
                            tabValue === 0
                              ? (
                                  !isFreeUser
                                    ? (
                                      <IntegrationsApiPage
                                        tabValue={tabValue}
                                        checkPlanForGrowthAndInfinty={checkPlanForGrowthAndInfinty}
                                        isFreeUser={isFreeUser}
                                        isEarlyBirdAccessUser={isEarlyBirdAccessUser}
                                        isAppSumoUser={isAppSumoUser}
                                        planName={planName}
                                        canEdit={canEdit}
                                      />
                                      )
                                    : (
                                      <CommonUpgradeModal
                                        open={openOverlay}
                                        currentPlan='free'
                                        closeModal={() => handleCloseOverlay(false)}
                                        title={tabValue === 0 ? 'Integrations' : 'Webhook'}
                                      />
                                      )
                                )
                              : (
                                  (checkPlanForGrowthAndInfinty() || isEarlyBirdAccessUser || isAppSumoUser)
                                    ? (
                                      <WebhookPage
                                        tabValue={tabValue}
                                        canEdit={canEdit}
                                        isFreeUser={isFreeUser}
                                      />
                                      )
                                    : (
                                      <CommonUpgradeModal
                                        currentPlan='free'
                                        open={openOverlay}
                                        closeModal={() => handleCloseOverlay(false)}
                                        title={tabValue === 0 ? 'Integrations' : 'Webhook'}
                                      />
                                      )
                                )
                        }
          </Box>

        </Box>
      </Box>
    </>

  )
}

export default IntegrationsAndWebhookPage
